import React from 'react';
import { connect } from 'react-redux';
import { isDirty, getFormInitialValues } from 'redux-form';
import { changeOutlet, pageRequest, submitForm } from 'actions/setting/receipt';
import { askConfirmAction } from 'actions/confirm-action';
import { browserHistory } from 'react-router';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { settingReceiptSave as settingReceiptSaveClevertap } from 'clevertap/settings/receipt';
import withFeatureFlags from 'hocs/withFeatureFlags';
import axios from 'axios';
import { push } from 'react-router-redux';
import styles from './Receipt.css';
import Header from './Header';
import ReceiptPreview from './ReceiptPreview';
import ReceiptForm from './ReceiptForm';
import ActionBar from './ActionBar';

class Receipt extends React.Component {
  componentDidMount() {
    $('#mk-col-right').show();
    this.props.dispatch(pageRequest(this.props.enableReceiptLogoPerOutlet));
    browserHistory.listenBefore(location => {
      if (this.props.data.isDirtyForm && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <ActionBar
          onChangeOutlet={this._onChangeOutlet}
          currentOutlet={this.props.data.outlet.currentOutlet}
        />
        <div className={styles.container}>
          <div
            className={`${styles['receipt-info-wrapper']} col-sm-6`}
            id="mk-col-left"
            style={{ paddingRight: 0 }}
          >
            <Header title="Receipt info" />
            <ReceiptForm onSubmit={this._onSubmit} />
          </div>
          <div
            className={`${styles['receipt-preview-wrapper']} col-sm-6`}
            id="mk-col-right"
          >
            <Header title="Receipt preview" />
            <ReceiptPreview />
          </div>
        </div>
        <ConfirmActionModal />
      </div>
    );
  }

  _onChangeOutlet = (outletIds = []) => {
    const { data, dispatch, enableReceiptLogoPerOutlet } = this.props;
    if (data.isDirtyForm) {
      dispatch(
        askConfirmAction(changeOutlet(outletIds, enableReceiptLogoPerOutlet))
      );
    } else {
      dispatch(changeOutlet(outletIds, enableReceiptLogoPerOutlet));
    }
  };

  _onSubmit = values => {
    const outletId = this.props.data.outlet.currentOutlet[0].id;
    const { business_id } = this.props.data.outlet.currentOutlet[0];

    const { uploadImage } = this.props.data.uploadImage;
    const { file } = uploadImage;
    const initialValues = this.props.initialFormValues;

    // if feature flag receipt-logo-per-outlet is on
    if (this.props.enableReceiptLogoPerOutlet) {
      this.convertImageToBase64(values.logo)
        .then(response => {
          const outlet = {
            address: values.address,
            city: values.city,
            name: values.name,
            notes: values.notes,
            province: values.province,
            phone_number: `0${values.phone}`,
            postal_code: values.zipcode,
            website: response ? values.website : '',
            twitter: response ? values.twitter : '',
            facebook: response ? values.facebook : '',
            instagram: response ? values.instagram : '',
          };

          let data = outlet;
          if (initialValues && initialValues.logo !== values.logo) {
            data = {
              ...outlet,
              image: response || '',
              filename: response ? file && file.name : '',
            };
          }

          settingReceiptSaveClevertap(values.logo, data, outletId, business_id);
          this.props.dispatch(
            submitForm(
              outletId,
              data,
              {},
              this.props.enableReceiptLogoPerOutlet
            )
          );
        })
        .catch(error => {
          Promise.reject(error);
        });
    } else {
      const data = {
        outlet: {
          address: values.address,
          city: values.city,
          name: values.name,
          notes: values.notes,
          province: values.province,
          phone_number: `0${values.phone}`,
          postal_code: values.zipcode,
        },
      };

      settingReceiptSaveClevertap(data.outlet, outletId, business_id);
      this.props.dispatch(
        submitForm(outletId, data, {}, this.props.enableReceiptLogoPerOutlet)
      );
    }
  };

  /**
   * Convert image to base64 format
   * @param imageFile can be url or blob file
   * @returns {Promise<string>}
   */
  convertImageToBase64 = imageFile => {
    if (imageFile) {
      return axios
        .create() /* used for remove the authorization */
        .get(imageFile, {
          /* prevent browser using cached image logo */
          headers: {
            'Cache-Control': 'no-cache',
          },
          responseType: 'arraybuffer',
        })
        .then(response =>
          Buffer.from(response.data, 'binary').toString('base64')
        )
        .catch(error => {
          return Promise.reject(error);
        });
    }
    return Promise.resolve(null);
  };
}

function mapStateToProps(state) {
  return {
    data: {
      isDirtyForm: isDirty('checkout')(state),
      outlet: state.outlet,
      uploadImage: state.uploadImage,
    },
    initialFormValues: getFormInitialValues('checkout')(state),
    nextAction: state.confirmAction.nextAction,
  };
}

const mapFlagsToProps = flags => {
  return {
    enableReceiptLogoPerOutlet: flags.receiptLogoPerOutlet,
  };
};

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(Receipt)
);
